<template>
  <span class="breadcrumb-item">
    <router-link class="breadcrumb-link" v-if="item.to" :to="item.to">{{ item.text }}</router-link>
    <span class="breadcrumb-link" v-else>{{ item.text }}</span>
    <span class="sep" v-if="item.to">{{separator}}</span>
  </span>
</template>
<script>
  export default {
    name: 'AppBreadcrumbItem',
    data() {
      return {
        separator: '',
      };
    },
    props: ['item'],
    mounted() {
      this.separator = this.$parent.separator;
    },
  };
</script>



// WEBPACK FOOTER //
// AppBreadcrumbItem.vue?3a6280ea